import { IFetchConciseDiagnosticOrderParams, IFetchConciseDiagnosticOrderResponse } from "../../interfaces/api/housemd/fetchConciseDiagnosticOrder"
import { IFetchDiagnosticSlotsUsingEkincareParams, IFetchDiagnosticSlotsUsingEkincareResponse } from "../../interfaces/api/housemd/fetchDiagnosticSlotsUsingEkincare"
import ApiUtils from "../ApiUtils"
import { IHouseMdService } from "./IHouseMdService"

const HouseMdUrls = {
	fetchSlotsUsingEkincare: ({ latitude, longitude, pincode, productCodes, userId }: IFetchDiagnosticSlotsUsingEkincareParams) =>
		`/slots?latitude=${latitude}&longitude=${longitude}&pincode=${pincode}&productCodes=${productCodes}&userId=${userId}`,
	fetchConciseDiagnosticOrder: "/order/concise?",
}

export default class HouseMdServiceApis implements IHouseMdService {
	getServiceUrl = (path: string): string => {
		return "/housemd" + path
	}
	fetchDiagnosticSlotsUsingEkincare = (params: IFetchDiagnosticSlotsUsingEkincareParams): Promise<IFetchDiagnosticSlotsUsingEkincareResponse> => {
		const url = this.getServiceUrl(HouseMdUrls.fetchSlotsUsingEkincare(params))
		return ApiUtils.get(url)
	}
	fetchConciseDiagnosticOrder = (params: IFetchConciseDiagnosticOrderParams): Promise<IFetchConciseDiagnosticOrderResponse> => {
		const url = this.getServiceUrl(HouseMdUrls.fetchConciseDiagnosticOrder) + ApiUtils.requestToQueryParams(params)
		return ApiUtils.post(url, null)
	}
}
